<template>
  <b-card header="Assign location for selected lock">
    <div class="card">
      <b-row>
        <div style="width: 100%; margin: 20px;">
          <ul class="fa-ul" style="margin-bottom: 0px;">
            <li>
              <i class="fa fa-info-circle fa-li"></i>
              <div id="select-location" v-if="locations.length > 0" class="alert alert-success">
              Please select location below.
              </div>
              <div id="no-location" v-if="locations.length == 0" class="alert alert-danger" >
              Please create location
              </div>

            </li>
          </ul>
        </div>
      </b-row>
      <!-- loop begin -->
      <b-row>
      <div class="col-sm-6 col-md-2" v-for="i in locations" :key="i.id" style="margin:10px;">
        <div class="card" style="height:100%;">
          <div class="card-body">

            <div class="h1 text-muted text-right mb-4">
              <b-button type="button" variant="primary" v-on:click="addLocationToLock(i.id)" style="margin-bottom:  10px;float:left;">
                <i class="fa fa-dot-circle-o"></i> Add
              </b-button>
              <i class="icon-location-pin"></i>
            </div>
            <div class="h4 mb-0">{{i.totalLocks}} <small class="text-muted text-uppercase font-weight-bold" style="font-size:9px;">locks</small></div>
            <div class="progress progress-xs mt-3 mb-0">
              <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted text-uppercase font-weight-bold" style="position:absolute; bottom:0;">{{i.name}}</small><br/>
          </div>
        </div>
      </div>
      </b-row>
      <!-- loop end -->
    </div>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'
//const API_LIST_LOCATION = BASE + '/api/locations/list'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

// async function getData () {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token')
//   }
//   let res = await postdata(API_LIST_LOCATION, parameters)
//   return res.locations
// }

export default {
  name: 'location-list-add-lock',
  props: ['locationName', 'locationId', 'nextItem'],
  data: () => {
    return {
      locations: []
    }
  },
  mounted () {
    if (localStorage.getItem('token')) {
      let localLocationsList = localStorage.getItem('localLocationsList')
        if(localLocationsList === null || localLocationsList === 'undefined') {
          constants.gotoLogin()
        } else {  

          this.$data.locations = JSON.parse(localLocationsList)
        }
//     }
      // getData().then(response => {
      //   alert(JSON.stringify(response))
      //   this.$data.locations = response
      // })
    }
  },
  methods: {
    addLocationToLock (newLocationId) {
      let lockId = this.$route.params.lockId
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        locationId: newLocationId
      }
      postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
        .then(data => {

          // let localLockList = localStorage.get
          // locl.parse
          // let foundLock = filterdadada
          // foundLock.locationId = newLocationId
          // let foundLocation = locallocationlistfilterdadada
          // foundLock.location = foundLocation
          // let indexLocalLockList localLockList.findIdex.....locId
          // localLockList[indexLocalLockList] = foundLock
          // localStorage.setitem

         

          // let localGetUnassigned = localStorage.getItem('localGetUnassigned')
          // localGetUnassigned = JSON.parse(localGetUnassigned)
          
          // let index = localGetUnassigned.findIndex(lock => lock.id == lockId)
          // let tmpLock = localGetUnassigned[index]
          // localGetUnassigned.splice(index, 1)
          // localStorage.setItem('localGetUnassigned', JSON.stringify(localGetUnassigned))


          // let LocalListAvailable = localStorage.getItem('localListAvailable')
          // LocalListAvailable = JSON.parse(LocalListAvailable)

          let localLocationsList = localStorage.getItem('localLocationsList')
          localLocationsList = JSON.parse(localLocationsList)
          let locIndex = localLocationsList.findIndex(loc => loc.id == newLocationId)
          let tempLocation = localLocationsList[locIndex]
          tempLocation.totalLocks = tempLocation.totalLocks + 1
          localLocationsList[locIndex] = tempLocation


           let localLockList = localStorage.getItem('localLocksList')
          localLockList = JSON.parse(localLockList)

          let foundLockIdx = localLockList.findIndex(lock => lock.id == lockId)
          let foundLock = localLockList[foundLockIdx]
          foundLock.locationId = newLocationId
          //alert('foundLock.locationId:  ' + foundLock.locationId)
          let foundLocationIdx = localLocationsList.findIndex(loc => loc.id == newLocationId)
          foundLock.location = localLocationsList[foundLocationIdx]
          localLockList[foundLockIdx] = foundLock

          localStorage.setItem('localLocksList', JSON.stringify(localLockList))
          localStorage.setItem('localLocationsList', JSON.stringify(localLocationsList))
          
          //   if(tmpLock.countTotal==0) {
          //     LocalListAvailable.push(tmpLock)
          //     localStorage.setItem('localListAvailable', JSON.stringify(LocalListAvailable))
          //   }

          location.href = '/'
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/LocationListAddLock.vue